// extracted by mini-css-extract-plugin
export default {"videoContainer":"VideoBox_videoContainer__iQlPm","video":"VideoBox_video__xpJMY","intro":"VideoBox_intro__hr4Yl"};